module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('action-modal', {
    ref: "modal",
    attrs: {
      "object": _vm.currentTarget,
      "buttonText": "Delete"
    },
    on: {
      "click": _vm.deleteTarget
    }
  }, [_vm._v("\n  Are you sure you want to delete target\n  "), _c('span', {
    staticClass: "delete-target-modal__delete-target-name",
    attrs: {
      "title": _vm.currentTarget.display_name
    }
  }, [_vm._v("\n     " + _vm._s(_vm.currentTarget.display_name) + "?\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64700720"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/targets/components/DeleteTargetModal.vue
// module id = 2497
// module chunks = 0